module.exports = __webpack_public_path__ + "img/svip2.e3c7d284.png";